import HBIcon from "@/components/HBIcon";
import { Button } from "antd";
import classNames from "classnames";
import { memo } from "react";
import { Else, If, Then } from "react-if";
import styles from "./index.module.less";
import OperationButton from "./operationButton";
/**
 * @param {*} followed 是否已关注
 * @param {*} onToggleFollow 关注切换
 */
function FollowButton({
  followed,
  onClick,
  btnText = "关注",
  className,
  showGrop = false,
  userInfo,
  ...props
}) {
  return (
    <div className={classNames(styles.follow_button, className)} {...props}>
      <If condition={followed}>
        <Then>
          {showGrop ? (
            <OperationButton
              onClick={onClick}
              userInfo={userInfo}
            ></OperationButton>
          ) : (
            <Button block onClick={onClick}>
              已关注
            </Button>
          )}
        </Then>
        <Else>
          <Button
            className={styles.focus}
            type="primary"
            block
            icon={<HBIcon type="ic_star" />}
            onClick={onClick}
          >
            {btnText}
          </Button>
        </Else>
      </If>
    </div>
  );
}

export default memo(FollowButton);
